/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import { TextField, Avatar, CircularProgress, Paper, Divider } from '@material-ui/core/';
import './roomspage.css';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import { updateRoom } from '@/app/services/rooms/rooms';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import Deleteconfirmdialogue from './Deleteconfirmdialogue';
import { getImageUrl } from '@/utils/utils';
import PageHeader from '@/app/customComponents/PageHeader';
import { useNavigate, useLocation } from 'react-router-dom';

const RoomSettings = () => {
	const dispatch = useDispatch();
	const [errTxts, setErrTxts] = useState({});
	const [isSaving, setIsSaving] = useState(false);
	const location = useLocation();
	const { row: room } = location.state;
	const navigate = useNavigate();
	const [modifiedRow, setModifiedRow] = useState({
		name: room?.name,
		school_id: room?.school_id,
		thumb: room?.thumb,
		room_type: room?.room_type,
		student_ratio_count: room?.student_ratio_count ?? '2',
		required_staff: room?.required_staff,
	});

	const inputRef = useRef(null);
	const [selectedFile, setSelectedFile] = useState();
	const [preview, setPreview] = useState(room?.thumb);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (name === 'name') {
			setErrTxts({ ...errTxts, sn: '' });
		}
		setModifiedRow({ ...modifiedRow, [name]: value });
	};

	const handledelete = () => {
		dispatch(
			Actions.openDialog({
				children: <Deleteconfirmdialogue row={room} />,
			})
		);
	};

	const handleupdate = () => {
		setErrTxts({});

		if (!modifiedRow.name) {
			setErrTxts({ ...errTxts, name: 'This field is required' });
			return;
		}
		if (modifiedRow.student_ratio_count == '') {
			setErrTxts({ ...errTxts, student_ratio_count: 'This field is required' });
			return;
		}
		if (modifiedRow.required_staff == '') {
			setErrTxts({ ...errTxts, required_staff: 'This field is required' });
			return;
		}
		if (
			(modifiedRow.name && modifiedRow.name.indexOf(' ') === 0) ||
			modifiedRow.name.lastIndexOf(' ') === modifiedRow.name.length - 1 ||
			/[^a-zA-Z ]/.test(modifiedRow.name)
		) {
			setErrTxts({ ...errTxts, name: 'Please enter a valid name.' });
			return;
		}

		if (selectedFile) {
			const filename = getImageUrl(selectedFile);
			setIsSaving(true);
			uploadFile(selectedFile, filename)
				.then((response) => {
					// modifiedRow.photo = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					modifiedRow.thumb = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
					updateRoom(room?.id, modifiedRow)
						.then((resp) => {
							dispatch(
								Actions.showMessage({
									message: resp.data.message,
									autoHideDuration: 1500,
									variant: 'success',
								})
							);
							navigate('/rooms');
						})
						.catch((err) => {
							if (err.response?.data?.errors) {
								setErrTxts(err.response.data.errors);
							} else {
								dispatch(
									Actions.showMessage({
										message: 'Failed to edit student information.',
										autoHideDuration: 1500,
										variant: 'error',
									})
								);
							}
						})
						.finally(() => setIsSaving(false));
				})
				.catch(() => {
					setIsSaving(false);
					dispatch(Actions.showMessage({ message: 'Failed to upload image', variant: 'error' }));
				});
		} else {
			setIsSaving(true);
			updateRoom(room?.id, modifiedRow)
				.then((resp) => {
					dispatch(
						Actions.showMessage({
							message: resp.data.message,
							autoHideDuration: 1500,
							variant: 'success',
						})
					);
					navigate('/rooms');
				})
				.catch((err) => {
					if (err.response?.data?.errors) {
						setErrTxts(err.response.data.errors);
					} else {
						dispatch(
							Actions.showMessage({
								message: 'Failed to edit room information.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					}
				})

				.finally(() => setIsSaving(false));
		}
	};

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(null);
			return;
		}

		setSelectedFile(e.target.files[0]);
	};

	const handleback = () => {
		navigate(-1);
	};

	useEffect(() => {
		if (!selectedFile) {
			setPreview(room?.thumb);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const handleNumberChange = (e) => {
		const { name, value } = e.target;
		if (/^[1-9]\d*$/.test(value) || value === '') {
			setModifiedRow({ ...modifiedRow, [name]: value });
		}
	};

	return (
		<div className="mt-16 md:mt-32 w-11/12 mx-auto max-w-3xl flex flex-col gap-32 mb-128">
			<PageHeader onBack={handleback} title={room?.room_type === 'place' ? 'Location Settings' : 'Room Settings'} />
			<Paper className="p-32 sm:p-64 flex flex-col gap-32">
				<div className="flex flex-col gap-32">
					<h2 className="" style={{ color: '#06071D', fontWeight: '700', fontSize: '18px' }}>
						Room Information
					</h2>
					<div>
						<div className=" flex flex-col justify-center sm:justify-start sm:flex-row sm:items-center gap-32 sm:gap-0">
							<div className=" mr-64">
								<div className="relative pic-upload-overlay cursor-pointer" onClick={() => inputRef.current.click()}>
									<Avatar className="imageupload" src={preview} style={{ height: '140px', width: '140px' }} />
									<div className="camera-icon">
										<i className="fa fa-2x fa-camera" />
									</div>
									<input
										className="hidden"
										id="image"
										name="image"
										onChange={onSelectFile}
										ref={inputRef}
										type="file"
									/>
								</div>
							</div>
							<div className="max-w-640 w-full flex flex-col gap-32 " style={{ fontWeight: 'normal' }}>
								<TextField
									className="textarea-input"
									error={!!errTxts.name}
									fullWidth
									helperText={errTxts.name}
									id="room_name"
									label="Room Name"
									name="name"
									onChange={handleChange}
									required
									value={modifiedRow.name}
								/>
							</div>
						</div>
						{room?.room_type !== 'place' ? (
							<>
								<Divider className="my-32" />
								<div className="flex flex-col gap-16">
									<h2 className="" style={{ color: '#06071D', fontWeight: '700', fontSize: '18px' }}>
										Room Ratio
									</h2>
									<p className="w-full sm:max-w-512">
										Set the ratio of students to staff for this room, and we’ll show you when the room is in and out of
										compliance based on real-time checkin data.
									</p>
									<div className="flex gap-32 sm:gap-48 flex-col sm:flex-row">
										<TextField
											error={!!errTxts.student_ratio_count}
											fullWidth
											helperText={errTxts.student_ratio_count}
											label="Number of Students"
											name="student_ratio_count"
											onChange={handleNumberChange}
											required
											value={modifiedRow.student_ratio_count}
										/>

										<TextField
											error={!!errTxts.required_staff}
											fullWidth
											helperText={errTxts.required_staff}
											label="Number of Teachers"
											name="required_staff"
											onChange={handleNumberChange}
											required
											value={modifiedRow.required_staff}
										/>
									</div>
								</div>
							</>
						) : null}
					</div>
				</div>
				{!isSaving ? (
					<div className="flex justify-center w-max my-24 mx-auto" style={{ gap: '20px' }}>
						<CustomButton
							fontSize="15px"
							height="55"
							id="update-room-btn"
							onClick={handleupdate}
							variant="primary"
							width="140px"
						>
							{room?.room_type == 'room' ? 'Update Room' : 'Update Location'}
						</CustomButton>
						<CustomButton
							fontSize="15px"
							height="55"
							id="delete-room-btn"
							onClick={handledelete}
							variant="secondary"
							width="140px"
						>
							{room?.room_type == 'room' ? 'Delete Room' : 'Delete Location'}
						</CustomButton>
					</div>
				) : (
					<div className="flex justify-center">
						<CircularProgress className="mx-auto" />
					</div>
				)}
			</Paper>
		</div>
	);
};

export default RoomSettings;
